// assets/age-verification.js
// Cookie de verificacion con trazabilidad
(function() {
  var AGE_COOKIE = 'age_verified_sexzon';
  var COOKIE_DAYS = 30;

  function setAgeCookie() {
    var data = {
      v: 1,
      t: Date.now(),
      s: Math.random().toString(36).substr(2, 12),
      d: 'v1.0'
    };
    var expires = new Date();
    expires.setDate(expires.getDate() + COOKIE_DAYS);
    document.cookie = AGE_COOKIE + '=' + btoa(JSON.stringify(data)) + '; expires=' + expires.toUTCString() + '; path=/; SameSite=Strict; Secure';
  }

  // Hook into ageVerificationAccept if it exists
  function hookIntoAccept() {
    var originalAccept = window.ageVerificationAccept;
    if (typeof originalAccept === 'function') {
      window.ageVerificationAccept = function() {
        setAgeCookie();
        originalAccept.apply(this, arguments);
      };
    }
  }

  // Also try getElementById approach as fallback
  function hookIntoButton() {
    var btn = document.getElementById('age-gate-yes');
    if (btn) {
      btn.addEventListener('click', setAgeCookie);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      hookIntoAccept();
      hookIntoButton();
    });
  } else {
    hookIntoAccept();
    hookIntoButton();
  }
})();